import moment from 'moment'
import React, { ReactNode } from 'react'
import DateBar from '../../common/date/DateBar'
import withDate, { WithDateProps } from '../../common/date/withDate'
import { RestrictedProvider } from '../auth/RestrictedContext'
import withActiveStation, { WithActiveStationProps } from '../station/withActiveStation'
import NoteSection from './NoteSection'
import WeeklyInfoTaskTable from './WeeklyInfoTaskTable'
import css from './weeklyInfoPage.css'
import type { NoteSectionType, SubjectType } from './weeklyInfoTypes'

type WeeklyInfoPageChildrenProps = {
  subject: SubjectType
  date: string
  currentWeek: string
  dateFormat: string
  onDateChange: (date: string) => void
  stationId: string
  salesIncentiveUnit: string
  companyId?: string
}

type WeeklyInfoPageProps = {
  subject: SubjectType
  children: (props: WeeklyInfoPageChildrenProps) => ReactNode
}

@withDate({
  dateFormat: 'GGGG[W]WW',
  paramName: 'week',
})
@withActiveStation
class WeeklyInfoPage extends React.PureComponent<WeeklyInfoPageProps> {
  render() {
    const { subject, date, dateFormat, onDateChange, activeStation } = this.props as WeeklyInfoPageProps &
      WithActiveStationProps &
      WithDateProps
    const previousWeek = moment(date, dateFormat).subtract(1, 'week').format(dateFormat)
    const currentWeek = moment(date, dateFormat).format(dateFormat)
    return (
      <div className={css.component}>
        <RestrictedProvider requiredPermission='edit_weeklyInfo'>
          <DateBar
            dateUnit='week'
            {...{
              date,
              dateFormat,
              onDateChange,
            }}
          />
          {this.props.children({
            subject,
            date: previousWeek,
            currentWeek: currentWeek,
            dateFormat,
            onDateChange,
            stationId: activeStation.id,
            salesIncentiveUnit: activeStation.salesIncentiveUnit,
            companyId: activeStation.company?.id,
          })}
          <NoteSection
            section={subject === 'Management' ? 'General' : (subject as NoteSectionType)}
            date={moment(date).format('YYYY-MM-DD')}
            stationId={activeStation.id}
          />
          <div className={css.taskTable}>
            <WeeklyInfoTaskTable stationId={activeStation.id} week={previousWeek} subject={subject} />
          </div>
        </RestrictedProvider>
      </div>
    )
  }
}

export default WeeklyInfoPage
